export default __webpack_public_path__ + "static/media/trr-food-worb_mongolian.67660e3b.png";